"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileToolbarPopup = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Iconista_1 = require("@jsonjoy.com/ui/lib/icons/Iconista");
const DropArea_1 = require("@jsonjoy.com/ui/lib/5-block/DropArea");
const EditorContextPopup_1 = require("../../chrome/EditorContextPopup");
const context_1 = require("./context");
const use_t_1 = require("use-t");
const FileToolbarPopup = () => {
    const [t] = (0, use_t_1.useT)();
    const state = (0, context_1.useFileButton)();
    const busy = state.busy.use();
    const dropState = React.useMemo(() => new DropArea_1.DropAreaState(async (files) => {
        const file = files[0];
        if (!file)
            return;
        await state.insertFromFile(file);
    }), [state]);
    return (React.createElement(EditorContextPopup_1.EditorContextPopup, { title: t('Insert file'), subtitle: t('Pick a file from your device, or drag and drop.'), minWidth: 360, applyLabel: t('Choose file…'), applyDisabled: busy, onCancel: state.close, onApply: dropState.pick },
        React.createElement(DropArea_1.DropArea, { state: dropState, multiple: false, paper: false, compact: true },
            React.createElement(Iconista_1.Iconista, { set: 'lucide', icon: 'upload', width: 24, height: 24 }),
            React.createElement("div", { className: "DropArea-text", style: { fontSize: 13, lineHeight: 1.4, textAlign: 'center' } }, busy ? t('Reading…') : t('Drop a file here, or click to pick')))));
};
exports.FileToolbarPopup = FileToolbarPopup;
